

import { h } from 'snabbdom';

/**
 * render link elem
 * @param elemNode slate elem
 * @param children children
 * @param editor editor
 * @returns vnode
 */
function renderTopic(elemNode, children) {
  const vNode = h(
    'span',
    {
      style: {
        color: '#2695f1',
      },
    },
    children,
  );
  return vNode;
}

const renderTopicConf = {
  type: 'topic', // 和 elemNode.type 一致
  renderElem: renderTopic,
};

export { renderTopicConf };
